// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3zRDy","actionsCol":"EnrolledClinics_actionsCol__2l9_Y"};